import HeaderFunnel from './HeaderFunnel/HeaderFunnel'
import HeaderCMS from './HeaderCMS/HeaderCMS'
import * as translator from '../../utils/translator'

/**
 * @param {Object} props
 * @param {string} props.stage
 * @param {string} [props.country]
 * @param {string} [props.language]
 * @param {boolean} [props.showSteps]
 * @param {string} [props.flow]
 * @param {boolean} [props.showBackButton]
 * @param {string} [props.headerVersion] - 'v1' for regular, 'v2' for cannabis
 * @param {boolean} [props.isCannabis] - Optional: if true, uses 'v2' header, if false uses 'v1' (overrides headerVersion if provided)
 */
function HeaderController({stage, country="", language="",showSteps = true, flow='regular', showBackButton=true, headerVersion, isCannabis, carePlusSteps=false}) {

  if (!country || !language){
    //find first 2 letters path
    let pathLocale = window.location.pathname.split("/").filter(path => path.length === 2)

    if (!country && pathLocale){
        country = pathLocale[0]
    }

    if (!country) {
      country="de"  
    }

    if (!language && pathLocale){
      language = pathLocale[1]
    }

    if (!language) {
      language = translator.getLanguageByCountry(country)
    }
  }

  // Determine headerVersion: isCannabis prop takes precedence, then headerVersion prop, then default to 'v1'
  let finalHeaderVersion = headerVersion;
  if (isCannabis !== undefined) {
    finalHeaderVersion = isCannabis ? 'v2' : 'v1';
  } else if (!finalHeaderVersion) {
    finalHeaderVersion = 'v1';
  }

  let header
  if(["Questionnaire", "Treatment", "Shipping", "Payment","LoginPage","RegistrationPage", "StartConsultation", "chooseDoctorAndAppointment", "CustomerVerification", "SignUp"].includes(stage)){
    header = <HeaderFunnel showBackButton={showBackButton} country={country} language={language} stage={stage} showSteps={showSteps} flow={flow} headerVersion={finalHeaderVersion} carePlusSteps={carePlusSteps}/>
  } else {
    header = <HeaderCMS country={country} />
  }
  
  return (
    <div id="funnel-header-container">
      {header}
    </div>
  )
  
}

export default HeaderController
